import Rooms from './rooms.png';
import Territory from './territory.png';

export const housesImgs = {
  Rooms,
  Territory,
};
